// extracted by mini-css-extract-plugin
export default {"root":"NotFoundAnimes_root__BNabF"};